import { Tooltip } from '@gilbarbara/components';
import AnimatingDots from '~/components/AnimatingDots';
import DropdownInput from '~/components/DropdownInput';
import Gap from '~/components/Gap';
import Text from '~/components/Text';
import InfoIcon from '~/icons/InfoIcon';
import { CURRENCY_LIST } from '~/utils/amount';
import BasicSection from '../InvoiceForm/BasicSection';
import CustomerSection from '../InvoiceForm/CustomerSection';
import NotesSection from '../InvoiceForm/NotesSection';
import SettingsAction from '../InvoiceForm/SettingsAction';
import { useInvoiceForm } from '../InvoiceForm/useInvoiceForm';
import styles from './invoiceFormPhone.module.scss';
import ItemFormSection from './ItemFormSection';
import SummarySectionPhone from './SummarySectionPhone';

const InvoiceFormPhone = () => {
  const { formData, setValue, isLoading } = useInvoiceForm({ isPhone: true });

  if (isLoading) {
    return (
      <div className="full-dimenstions center">
        <AnimatingDots />
      </div>
    );
  }

  return (
    <div className={`full-width`}>
      <div className={styles.mainForm}>
        <div className={styles.formSubsection}>
          <BasicSection formData={formData} setValue={setValue} />

          <Gap t={16} />

          <div className="align-center">
            <Text size="xs">Currency</Text>
            <Gap l={8} />
            <Tooltip
              content="Currency will be picked from Client"
              eventType="click"
              placement="right-start"
            >
              <InfoIcon className="cursor-pointer" />
            </Tooltip>
          </div>

          <Gap t={4} />
          <DropdownInput
            value={formData.currency}
            onChange={(newVal: any) => {
              setValue({
                currency: newVal,
              });
            }}
            options={CURRENCY_LIST}
            disabled
          />
        </div>

        <Gap t={24} />
        <div className={styles.divider} />

        <div className={styles.formSubsection}>
          <CustomerSection formData={formData} setValue={setValue} />
        </div>

        <Gap t={24} />
        <div className={styles.divider} />

        <div className={styles.formSubsection}>
          <ItemFormSection formData={formData} setValue={setValue} />
        </div>

        <div className={styles.divider} />
        <SummarySectionPhone formData={formData} setValue={setValue} />

        <div className={styles.divider} />

        <div className={styles.formSubsection}>
          <NotesSection formData={formData} setValue={setValue} />
        </div>

        <div className={styles.divider} />
        <SettingsAction templateId={formData.template_id} />
      </div>
    </div>
  );
};

export default InvoiceFormPhone;
